import api from '../../../../api/client'

export async function listDepartments(params) {
  const { data } = await api.get('/departments/', { params })
  return data
}

export async function getDepartmentDetail(departmentId) {
  const { data } = await api.get(`/departments/${departmentId}`)
  return data
}

export async function createDepartment(payload) {
  const { data } = await api.post('/departments/', payload)
  return data
}

export async function updateDepartment(departmentId, payload) {
  const { data } = await api.put(`/departments/${departmentId}`, payload)
  return data
}

export async function archiveDepartment(departmentId) {
  const { data } = await api.post(`/departments/${departmentId}/archive`)
  return data
}

export async function deleteDepartment(departmentId) {
  const { data } = await api.post(`/departments/${departmentId}/delete`)
  return data
}

export async function listDepartmentCompanyOptions(params) {
  const { data } = await api.get('/options/companies', { params })
  return Array.isArray(data) ? data : []
}

export async function listDepartmentBranchOptions(params) {
  const { data } = await api.get('/options/branches', { params })
  return Array.isArray(data) ? data : []
}

export async function listDepartmentUserOptions(params) {
  const { data } = await api.get('/options/users', { params })
  return Array.isArray(data) ? data : []
}
